import React from 'react';
import { SaveIcon } from 'lucide-react';

import Layout1Form from './forms/Layout1Form';
import Layout2Form from './forms/Layout2Form';
import Layout3Form from './forms/Layout3Form';
import Layout4Form from './forms/Layout4Form';
import Layout4BForm from './forms/Layout4BForm';
import Layout4CForm from './forms/Layout4CForm';
import Layout6Form from './forms/Layout6Form';
import Layout7Form from './forms/Layout7Form';
import './FormFields.css';
import Layout5Form from './forms/Layout5Form';

const FormFields = ({ layout, data, onChange, errors, onSave }) => {
  return (
    <div className="form-fields">
      <div className="form-fields-header">
        <h2>Edit Content</h2>
        <button className="save-button" onClick={onSave}>
          <SaveIcon className="mr-1" /> Save
        </button>
      </div>

      {layout === 'layout1' && (
        <Layout1Form data={data} onChange={onChange} errors={errors} />
      )}
      {layout === 'layout2' && (
        <Layout2Form data={data} onChange={onChange} errors={errors} />
      )}
      {layout === 'layout3' && (
        <Layout3Form data={data} onChange={onChange} errors={errors} />
      )}
      {layout === 'layout4' && (
        <Layout4Form data={data} onChange={onChange} errors={errors} />
      )}
      {layout === 'layout4B' && (
        <Layout4BForm data={data} onChange={onChange} errors={errors} />
      )}
      {layout === 'layout4C' && (
        <Layout4CForm data={data} onChange={onChange} errors={errors} />
      )}
      {layout === 'layout6' && (
        <Layout6Form data={data} onChange={onChange} errors={errors} />
      )}
      {layout === 'layout7' && (
        <Layout7Form data={data} onChange={onChange} errors={errors} />
      )}
      {layout === 'layout5' && (
        <Layout5Form data={data} onChange={onChange} errors={errors} />
      )}
    </div>
  );
};

export default FormFields;
